export class UserEntityProfileBase {

    id!: number
    userId!: number
    userEntityId!: number
    type!: number
    code?: string
    applicationId?: number

    static fromUserEntityProfile(uep: UserEntityProfile): UserEntityProfile {
        let current = new UserEntityProfileBase()
        Object.assign(current, uep)

        return current
    }
}

export interface UserEntityProfile extends UserEntityProfileBase {

}
